module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "subtitle-1 ma-0"
  }, [_vm._v("\n            Ensure that you have an active account on our KOBE platform:\n            "), _c('a', {
    attrs: {
      "href": "https://app.getkobe.com"
    }
  }, [_vm._v("https://app.getkobe.com")]), _vm._v(" with all your updated details.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 ma-0"
  }, [_vm._v("Reminder:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Both client and influencer will be mutually rated after each campaign and all scores will be kept confidential.")]), _vm._v(" "), _c('li', [_vm._v("Submitting of drafts and payments will be done seamlessly via our Kobe platform (your payout will be credited to your bank account once your post goes live and statistics uploaded on our platform)")]), _vm._v(" "), _c('li', [_vm._v("Do not live your post until you have received clearance from us, you will be notified through our platform and your email.")]), _vm._v(" "), _c('li', [_vm._v("For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation and penalty from the campaign.")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("Campaign summary")]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6",
      "align": "left",
      "justify": "center"
    }
  }, [_c('p', {
    staticClass: "headline font-regular font-weight-bold ml-2"
  }, [_vm._v(_vm._s(_vm.brief.campaignName))]), _vm._v(" "), (_vm.status === _vm.statusINVITED) ? _c('div', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.doReject('not_interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('inquiry')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-help")]), _vm._v("Inquiry\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('div', [_c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "success"
    },
    on: {
      "click": function($event) {
        return _vm.doAction('interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Interested\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "tile": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.doReject('not_interested')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-cancel")]), _vm._v("Not Interested\n                ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "info",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-help-circle-outline ")])], 1), _vm._v("You have asked the question about this invitation.\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusINTERESTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-checkbox-marked-circle")])], 1), _vm._v("You are interested in this campaign\n                ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTINTERESTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1), _vm._v("You have not interested in this invitation.\n                ")], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("Reasons of rejection")]), _vm._v(" "), (_vm.rejectReasons) ? _c('ul', [(_vm.rejectReasons.campaign_proposed) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_proposed))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.campaign_timeline) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.campaign_timeline))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.payout_issue) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.payout_issue))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.competitor) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.competitor))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.not_associate) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.not_associate))]) : _vm._e(), _vm._v(" "), (_vm.rejectReasons.others) ? _c('li', [_vm._v(_vm._s(_vm.rejectReasons.others))]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusACCEPTED) ? _c('div', [_c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You are interested in this campaign\n                  ")], 1)], 1), _vm._v(" "), _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You have been accepted for this campaign.\n                  ")], 1)], 1), _vm._v(" "), ((_vm.isAgree === 0 || _vm.isAgree === undefined)) ? _c('div', [(_vm.briefDetailsHTML) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin": "20px 10px 0 10px"
    }
  }, [_vm._v("\n                  Review invoice and terms here.\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.briefDetailsHTML) ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.showAgreement
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v("Invoice and Contract\n                  ")], 1) : _vm._e()], 1) : _c('div', [(_vm.isAgree) ? _c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "success",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-check")])], 1), _vm._v("You have agreed to the terms and conditions.\n                  ")], 1) : _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white",
      "small": _vm.$vuetify.breakpoint.mobile
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-cancel")])], 1), _vm._v("\n                      You do not agree to the terms and conditions.\n                    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "rounded": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.showAgreement
    }
  }, [_vm._v("Change your mind?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "500",
      "margin-left": "15px"
    }
  }, [_vm._v("A Kobe representative will be in touch.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.status === _vm.statusNOTACCEPTED) ? _c('div', [_c('v-chip', {
    staticClass: "ma-2",
    attrs: {
      "color": "red",
      "text-color": "white"
    }
  }, [_c('v-avatar', {
    attrs: {
      "left": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1), _vm._v("You have been not accepted for this campaign.\n                ")], 1)], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "sm": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "headline font-regular"
  }, [_vm._v("\n                Payout:\n                "), (_vm.GST) ? _c('span', {
    staticClass: "success--text bold headline"
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.payout + (_vm.payout * 0.08))))]) : _c('span', {
    staticClass: "success--text bold headline"
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.payout)))])]), _vm._v(" "), _c('p', {
    staticClass: "title ma-0 font-regular"
  }, [_vm._v("Deliverables")]), _vm._v(" "), (_vm.deliverables) ? _c('ul', [(_vm.deliverables.no_of_posts) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_posts))]), _vm._v(" x Instagram Post\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_stories) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_stories))]), _vm._v(" x Instagram Stories\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_carousels) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_carousels))]), _vm._v(" x Instagram Carousel\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_video) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_video))]), _vm._v(" x Instagram Video\n                ")]) : _vm._e(), _vm._v(" "), (_vm.deliverables.no_of_igTv) ? _c('li', [_c('strong', [_vm._v(_vm._s(_vm.deliverables.no_of_igTv))]), _vm._v(" x Instagram TV\n                ")]) : _vm._e()]) : _vm._e()])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.status === _vm.statusINQUIRY) ? _c('v-row', [_c('v-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("\n            Recent Questions\n        ")]), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "tile": "",
      "color": "info"
    },
    on: {
      "click": _vm.inquiryBox
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("New Question\n          ")], 1), _vm._v(" "), _c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUnderLine || this.loadAllQuestoins.length > 0),
      expression: "showUnderLine || this.loadAllQuestoins.length > 0"
    }]
  }), _vm._v(" "), _c('QandA', {
    key: _vm.QandAComponentKey,
    attrs: {
      "Questions": _vm.loadAllQuestoins,
      "campaignID": this.$route.params.campaignID,
      "influencerID": this.influencer,
      "TriggerEmail": true,
      "pairedID": _vm.pairingID
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [((_vm.status === _vm.statusINTERESTED || _vm.status === _vm.statusACCEPTED || _vm.status === _vm.statusNOTACCEPTED) && (_vm.briefDetailsHTML && _vm.briefDetailsHTML !== {})) ? _c('v-col', {
    attrs: {
      "col": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "font-regular"
  }, [_vm._v("\n            Brief Details\n            "), _c('hr')]), _vm._v(" "), _c('v-card-text', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(this.briefDetailsHTML)
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brief.campaignBackground),
      expression: "brief.campaignBackground"
    }]
  }, [_c('v-card', {
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("\n          Campaign Background\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.brief.campaignBackground))])])], 1)], 1)], 1), _vm._v(" "), _c('reject-modal', {
    attrs: {
      "dialog": _vm.showRejectModal,
      "close": _vm.closeRejectModal,
      "pairingID": _vm.pairingID,
      "updateStatus": _vm.updatStatus
    }
  }), _vm._v(" "), _c('influencer-contract-modal', {
    attrs: {
      "dialogTitle": "Invoice and Contract",
      "dialog": _vm.showContractModal,
      "close": _vm.closeInfluencerContractModal,
      "contract": _vm.influencerContract,
      "didAgree": _vm.didAgree,
      "didNotAgree": _vm.didNotAgree,
      "showTerms": true,
      "showSendButton": false,
      "showSubmitButton": true,
      "showDeclineButton": true,
      "showOptions": true,
      "showCancelButton": false,
      "isAgreement": true,
      "briefDetailHTML": _vm.briefDetailsHTML
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5604e144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignInvite/CampaignInviteDetail.vue
// module id = 2133
// module chunks = 0